import { render, staticRenderFns } from "./PageNews.vue?vue&type=template&id=1573e8bf&"
import script from "./PageNews.vue?vue&type=script&lang=js&"
export * from "./PageNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports